import { useEffect } from 'react';
import { AppHeader } from '../components/layout/AppHeader';
import { PageShell } from '../components/layout/PageShell';
import { INFO_PAGE_CONTENT, type InfoPageId } from '../content/infoPages';
import { navigate } from '../hooks/useHashRoute';

export function InfoPage({ page }: { page: InfoPageId }): React.JSX.Element {
  const content = INFO_PAGE_CONTENT[page];

  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${content.title} · Pilum Trade Lab`;
    return () => {
      document.title = previousTitle;
    };
  }, [content.title]);

  return (
    <div className="app-shell">
      <AppHeader currentPage={page} />
      <PageShell>
        <div className="page-stack">
          <div className="info-column">
            <button className="info-back" type="button" onClick={() => navigate('/')}>← Back to opportunity tables</button>

            <header className="info-header">
              <h1 className="info-title">{content.title}</h1>
              <p className="info-tagline">{content.tagline}</p>
              <span className="info-updated">Last updated {content.lastUpdated}</span>
            </header>

            <div className="info-body">
              {content.sections.map((section) => (
                <section className="info-section" key={section.heading}>
                  <h2 className="info-section-title">{section.heading}</h2>
                  {section.paragraphs?.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                  {section.bullets && (
                    <ul className="info-bullets">
                      {section.bullets.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  )}
                  {section.note && <div className="info-note">{section.note}</div>}
                </section>
              ))}
            </div>

            <footer className="info-footer">
              <p>Pilum Trade Lab is a research and monitoring tool, not financial advice. See the{' '}
                <a className="info-inline-link" href="#/disclaimer" onClick={(event) => { event.preventDefault(); navigate('/disclaimer'); }}>Disclaimer</a>,{' '}
                <a className="info-inline-link" href="#/terms" onClick={(event) => { event.preventDefault(); navigate('/terms'); }}>Terms &amp; Conditions</a>, and{' '}
                <a className="info-inline-link" href="#/privacy" onClick={(event) => { event.preventDefault(); navigate('/privacy'); }}>Privacy Policy</a>.
              </p>
            </footer>
          </div>
        </div>
      </PageShell>
    </div>
  );
}
